const complianceDocumentMobileMedia = window.matchMedia('(max-width: 749px)');

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const opener = event.target.closest('modal-opener[data-modal="#ComplianceDocumentModal"]');
  const complianceDocumentLink = event.target.closest('a');
  const openedFromLink = Boolean(complianceDocumentLink && !opener && isComplianceDocumentLink(complianceDocumentLink));

  if (!opener && !openedFromLink) return;

  const modal = document.querySelector('#ComplianceDocumentModal');
  if (!modal) return;

  if (openedFromLink) {
    event.preventDefault();
    modal.show(complianceDocumentLink);
  }

  const viewer = modal.querySelector('.compliance-document-modal__viewer');
  if (!viewer?.dataset.src) return;

  const src = openedFromLink ? complianceDocumentLink.href : viewer.dataset.src;
  updateComplianceDocumentViewer(modal, src);
});

complianceDocumentMobileMedia.addEventListener('change', () => {
  const modal = document.querySelector('#ComplianceDocumentModal');
  if (!modal?.hasAttribute('open')) return;

  const viewer = modal.querySelector('.compliance-document-modal__viewer');
  const src = modal.dataset.currentDocumentUrl || viewer?.dataset.src;
  if (src) updateComplianceDocumentViewer(modal, src);
});

function updateComplianceDocumentViewer(modal, src) {
  const viewer = modal.querySelector('.compliance-document-modal__viewer');
  if (!viewer) return;

  modal.dataset.currentDocumentUrl = src;
  const fallback = modal.querySelector('.compliance-document-modal__fallback a');
  if (fallback && fallback.getAttribute('href') !== src) {
    fallback.setAttribute('href', src);
  }

  const showsMobileImage =
    complianceDocumentMobileMedia.matches && modal.querySelector('.compliance-document-modal__image');

  if (showsMobileImage) {
    viewer.removeAttribute('src');
  } else if (viewer.getAttribute('src') !== src) {
    viewer.setAttribute('src', src);
  }
}

function isComplianceDocumentLink(link) {
  if (!link) return false;

  const complianceDocumentContainer = link.closest('[data-compliance-document-url]');
  const complianceDocumentUrl = complianceDocumentContainer?.dataset.complianceDocumentUrl;
  if (!complianceDocumentUrl) return false;

  try {
    const linkUrl = new URL(link.href, document.baseURI);
    const documentUrl = new URL(complianceDocumentUrl, document.baseURI);
    return linkUrl.origin === documentUrl.origin && linkUrl.pathname === documentUrl.pathname;
  } catch {
    return false;
  }
}
